import instance from '../helpers/interceptor';

export const getAllMenus = async () => {
    try {
        const response = await instance.get('/menumaster');
        return response;
    } catch (error) {
        console.error('Error in getAllMenus:', error);
        throw error;
    }
};

export const updateMenu = async (menuData) => {
    try {
        const response = await instance.put('/menumaster/menu', menuData);
        return response;
    } catch (error) {
        console.error('Error in updateMenu:', error);
        throw error;
    }
};

export const updateSubmenu = async (submenuData) => {
    try {
        const response = await instance.put('/menumaster/submenu', submenuData);
        return response;
    } catch (error) {
        console.error('Error in updateSubmenu:', error);
        throw error;
    }
};

export const updateSubmenuSequence = async (sequenceUpdates) => {
    try {
        const currentUser = JSON.parse(sessionStorage.getItem('userData') || '{}');
        const response = await instance.put('/menumaster/submenu/sequence', {
            sequenceUpdates,
            modifiedBy: currentUser.userId || 'system'
        });
        return response;
    } catch (error) {
        console.error('Error in updateSubmenuSequence:', error);
        throw error;
    }
};